import { render, staticRenderFns } from "./ScreeCompany.vue?vue&type=template&id=62694d44&scoped=true&"
import script from "./ScreeCompany.vue?vue&type=script&lang=js&"
export * from "./ScreeCompany.vue?vue&type=script&lang=js&"
import style0 from "./ScreeCompany.vue?vue&type=style&index=0&id=62694d44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62694d44",
  null
  
)

export default component.exports